import React from "react";
import swal from "sweetalert";
import ResumeService from "../services/resume_service";


class Resume extends React.Component {
  state = {
    isLoading: true,

    totalAmount: 0,
    totalKm: "0 kms",
    totalServices: 0,
    totalTime: "0 min",
    usuariosTotales: 0,
    driversTotales: 0,
    deliveryTotales: 0,
  }


  componentDidMount() {
    swal("Cargando ...");
    new ResumeService().getResume().then(response => {
      this.setState({
        totalAmount: response.totalAmount,
        totalKm: response.totalKm.toPrecision() + " kms",
        totalServices: response.totalServicios,
        totalTime: response.totalTime,
        usuariosTotales: response.usuariosTotales,
        driversTotales: response.driversTotales,
        deliveryTotales: response.deliveryTotales,
      });
      swal.close();
    });
  }

  renderCard(params: { title: string, subtitle: string }) {
    return (
      <div className="card card-resume">
        <div className="card-image card-title-container">
          <h1>{params.title}</h1>
        </div>
        <div className="card-content">
          <div className="media">
            <div className="media-content">
              <p className="title is-4">{params.subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="resume-container">
        {this.renderCard({ title: this.state.totalAmount + " MXN", subtitle: "Dinero Recaudado del Día" })}
        {this.renderCard({ title: this.state.totalKm, subtitle: "Kilometros Recorridos" })}
        {this.renderCard({ title: this.state.totalServices.toString(), subtitle: "Servicios Completados" })}
        {this.renderCard({ title: this.state.totalTime, subtitle: "Tiempo en Conduccion" })}

        {this.renderCard({ title: this.state.usuariosTotales.toString(), subtitle: "Usuarios Totales" })}
        {this.renderCard({ title: this.state.driversTotales.toString(), subtitle: "Conductores Totales" })}
        {this.renderCard({ title: this.state.deliveryTotales.toString(), subtitle: "Deliveries Totales" })}
      </div>
    );
  }
}

export default Resume;